import { useEffect, useState } from 'react';
import { Card } from './ui/card';
import Axios from '../Axios';
import toast from 'react-hot-toast';
// const openPositions = [
//   {
//     symbol: 'BTC/USDT',
//     badge: 'High Low',
//     positionId: 'Position #1',
//     direction: 'UP',
//     amount: '$50.00',
//     entryPrice: '$100',
//     currentPrice: '$266',
//     payout: '$180',
//     status: 'In Profit',
//     expiresIn: '45s',
//     details: {
//       placedAt: '2026-02-27 14:32:10',
//       leverage: '1.95x',
//       strikePrice: '$245.65',
//       pnl: '+$52.50'
//     }
//   },
//   {
//     symbol: 'ETH/USDT',
//     badge: 'Up Down',
//     positionId: 'Position #2',
//     direction: 'UP',
//     amount: '$100.00',
//     entryPrice: '$25',
//     currentPrice: '$42.245',
//     payout: '$300',
//     status: 'In Profit',
//     expiresIn: '145s',
//     details: {
//       placedAt: '2026-02-27 14:28:22',
//       leverage: '1.95x',
//       strikePrice: '$42.11',
//       pnl: '+$185.50'
//     }
//   },
//   {
//     symbol: 'SOL/USDT',
//     badge: 'Tap trading',
//     positionId: 'Position #3',
//     direction: '20X',
//     amount: '$200.00',
//     entryPrice: '$250',
//     currentPrice: '$97.00',
//     payout: '$256',
//     status: 'Pending',
//     expiresIn: 'Instant',
//     details: {
//       placedAt: '2026-02-27 14:20:05',
//       leverage: '20x',
//       strikePrice: '$97.20',
//       pnl: '$0.00'
//     }
//   }
// ];
const formatNumber = (value, digits = 4) => {
  if (!Number.isFinite(value)) {
    return 0;
  }
  const number = parseFloat(Number(value).toFixed(digits));
  return number;
}

const formatDateTime = (dateTimeString) => {
  // DD/MM/YYYY / HH:mm:ss
  const date = new Date(dateTimeString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const amPmHours = hours > 12 ? "PM" : "AM";
  return `${day}-${month}-${year} / ${hours}:${minutes}:${seconds} ${amPmHours}`;
}
export function OpenPositionsPage() {
  const [expandedSymbol, setExpandedSymbol] = useState(null);
  const [positions, setPositions] = useState([]);
  const [totalForexPositions, setTotalPositions] = useState(0);
  const [type, setType] = useState('forex');
  const [closingTradeId, setClosingTradeId] = useState(null);
  const getForexPositions = async () => {
    try {
      const payload = {
        type: "pending"
      }
      const { data } = await Axios.post('/users/getForexTradeHistory', payload,);
      if (data?.success) {
        setPositions(data?.result || []);
        setTotalPositions(data?.total || 0);
      } else {
        setPositions([]);
        setTotalPositions(0);
      }
    } catch (error) {
      setPositions([]);
      setTotalPositions(0);
      console.log(error);
    }
  }
  const getCommoditiesPositions = async () => {
    try {
      const payload = {
        type: "pending"
      }
      const { data } = await Axios.post('/users/getCommoditiesTradeHistory', payload,);
      if (data?.success) {
        setPositions(data?.result || []);
        setTotalPositions(data?.total || 0);
      } else {
        setPositions([]);
        setTotalPositions(0);
      }
    } catch (error) {
      setPositions([]);
      setTotalPositions(0);
      console.log(error);
    }
  }

  const closeTrade = async (trade) => {
    if (!trade?._id) {
      return;
    }

    const closeEndpoint = type === 'commodities'
      ? '/users/placeCommoditiesTrade'
      : '/users/placeForexTrade';

    const payload = {
      id: trade._id,
      type: 'close',
    };

    if (Number.isFinite(Number(trade?.currentPrice))) {
      payload.closed_price = Number(trade.currentPrice);
    }

    try {
      setClosingTradeId(trade._id);
      const { data } = await Axios.post(closeEndpoint, payload);

      if (data?.success) {
        toast.success(data?.message || 'Trade closed successfully');
        if (type === 'forex') {
          await getForexPositions();
        } else {
          await getCommoditiesPositions();
        }
      } else {
        toast.error(data?.message || 'Failed to close trade');
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || error?.message || 'An error occurred while closing the trade');
    } finally {
      setClosingTradeId(null);
    }
  }

  useEffect(() => {
    if (type === 'forex') {
      getForexPositions();
    } else {
      getCommoditiesPositions();
    }
  }, [type])
  return (<section className="open-positions-page">
    <header className="open-positions-header">
      <h1>Open Positions</h1>
      <p>Manage your active trades</p>
    </header>

    <div className="history-filters" role="group" aria-label="Market filters">
      <button type="button" className={`history-filter ${type === 'forex' ? 'is-active' : ''}`} onClick={() => {
        setType('forex');
        setExpandedSymbol(null);
      }}>
        Forex
      </button>
      <button type="button" className={`history-filter ${type === 'commodities' ? 'is-active' : ''}`} onClick={() => {
        setType('commodities');
        setExpandedSymbol(null);
      }}>
        Commodities
      </button>
    </div>

    <section className="open-positions-summary">
      <Card as="article" className="summary-card">
        <p>Active Positions</p>
        <strong>{totalForexPositions}</strong>
      </Card>
      <Card as="article" className="summary-card summary-card--accent">
        <p>Potential Return</p>
        <strong>$875.50</strong>
      </Card>
    </section>

    <section className="open-positions-list">
      {positions.map((position) => (<Card as="article" key={position._id} className="open-position-card">
        <header className="open-position-card__head">
          <div>
            <h2>{position.symbol}</h2>
            <span className="position-type-pill">{type === 'forex' ? 'Forex' : 'Commodities'}</span>
            <p>{position.positionId}</p>
          </div>
          {/* <div className="position-expiry">
            <span>Expires in</span>
            <strong>{position.expiresIn}</strong>
          </div> */}
        </header>

        <div className="open-position-card__meta">
          <p>
            <span>Side</span>
            <strong className={position?.side === "buy" ? 'meta-up' : 'meta-down'}>
              {position?.side ? position.side.toUpperCase() : "-"}
            </strong>
            {/* <strong className={position.direction === 'UP' ? 'meta-up' : ''}>
              {position.direction === 'UP' ? '^ ' : ''}
              {position.direction}
            </strong> */}
          </p>
          <p>
            <span>Amount</span>
            <strong>{position?.quantity ? formatNumber(position?.quantity) : "-"}</strong>
          </p>
          <p>
            <span>Entry Price</span>
            <strong>{position?.price ? formatNumber(position?.price) : "-"}</strong>
          </p>
          <p>
            <span>Current Price</span>
            <strong>{position?.currentPrice ? formatNumber(position?.currentPrice) : "-"}</strong>
          </p>
          <p>
            <span>PNL</span>
            <strong className="meta-up">{position?.payout ? formatNumber(position?.payout) : "0"}</strong>
          </p>
          <p>
            <span>Status</span>
            <strong className={position?.status === 'Pending' ? 'meta-pending' : "meta-up"}>
              {position?.status === "Pending" ? "Opened" : position?.status}
            </strong>
          </p>
        </div>

        <div className="open-position-card__actions">
          <button
            type="button"
            className="position-action position-action--danger"
            onClick={() => closeTrade(position)}
            disabled={closingTradeId === position._id}
          >
            {closingTradeId === position._id ? 'Closing...' : 'Close Position'}
          </button>
          <button type="button" className={`position-action ${expandedSymbol === position.symbol ? 'is-active' : ''}`} onClick={() => setExpandedSymbol((previous) => previous === position.symbol ? null : position.symbol)}>
            {expandedSymbol === position.symbol ? 'Hide Details' : 'View Details'}
          </button>
        </div>

        {expandedSymbol === position?.symbol ? (<div className="open-position-card__accordion">
          <p>
            <span>Placed At</span>
            <strong>{position?.createdAt ? formatDateTime(position?.createdAt) : "-"}</strong>
          </p>
          {/* <p>
            <span>Leverage</span>
            <strong>{position?.details?.leverage}</strong>
          </p>
          <p>
            <span>Strike Price</span>
            <strong>{position?.details?.strikePrice}</strong>
          </p> */}
          {/* <p>
            <span>Running PnL</span>
            <strong className={position?.details?.pnl?.startsWith('+') ? 'meta-up' : 'meta-pending'}>
              {position?.details?.pnl}
            </strong>
          </p> */}
        </div>) : null}
      </Card>))}
    </section>
  </section >);
}
